export interface SplitQboQualifiedName {
  primary: string
  parentPath?: string
}

const PATH_SEPARATOR = ' › '

export function splitQboQualifiedName(name: string): SplitQboQualifiedName {
  const trimmed = name.trim()
  if (!trimmed) {
    return { primary: name }
  }

  const parts = trimmed
    .split(':')
    .map((part) => part.trim())
    .filter(Boolean)

  if (parts.length <= 1) {
    return { primary: trimmed }
  }

  const primary = parts[parts.length - 1]!
  const parentPath = parts.slice(0, -1).join(PATH_SEPARATOR)
  return { primary, parentPath }
}

export interface QualifiedSelectOption {
  id: string
  label: string
  hint?: string
  caption?: string
}

function accountTypeCaption(
  accountType: string | null | undefined,
  label: string,
  parentPath?: string
): string | undefined {
  const trimmed = accountType?.trim()
  if (!trimmed) return undefined

  const lower = trimmed.toLowerCase()
  if (label.toLowerCase() === lower) return undefined

  if (parentPath) {
    const segments = parentPath.split(PATH_SEPARATOR).map((part) => part.trim())
    if (segments.some((segment) => segment.toLowerCase() === lower)) return undefined
  }

  return trimmed
}

export function toQualifiedSelectOption(
  name: string,
  accountType?: string | null
): QualifiedSelectOption {
  const { primary, parentPath } = splitQboQualifiedName(name)
  const caption = accountTypeCaption(accountType, primary, parentPath)
  return {
    id: name,
    label: primary,
    ...(parentPath ? { hint: parentPath } : {}),
    ...(caption ? { caption } : {}),
  }
}
